const branch = process.env.REACT_APP_BRANCH || ''

/**
 * Southampton uses Stripe for memberships (Nest API).
 * Kingston / Redhill keep the GoCardless redirect + /Memberships/subscribe flow.
 * Override with REACT_APP_STRIPE_MEMBERSHIPS=true|false if needed.
 */
const stripeMembershipsEnv = process.env.REACT_APP_STRIPE_MEMBERSHIPS
const useStripeMemberships =
  stripeMembershipsEnv === 'true'
    ? true
    : stripeMembershipsEnv === 'false'
      ? false
      : branch === 'Southampton'

const config = {
  branch,
  endpoint: branch + 's',
  serverURL: process.env.REACT_APP_API_URL || 'https://api.wackykingdom.com/api',
  useStripeMemberships
}

export default config
